import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService';
import { setAfeFleetHeaderDetail, setAfeFleetItemDetails, setAfeFleetTaskDetails, setAfeOrderHeaderDetail, setAssetAssignedToForAllItem, setAssetFleetHeaderDetail, setAssetFleetItemDetails, setAssetFleetTaskDetails, setAssetOrderHeaderDetail } from 'Store/FleetManagement/AssetFleetProcessing/AssetFleetProcessingAction';
import { GET_AFE_FLEET_HEADER_DETAILS, GET_AFE_FLEET_ITEM_DETAILS, GET_AFE_FLEET_TASK_DETAILS, GET_AFE_ORDER_HEADER_DETAILS, GET_ASSET_FLEET_HEADER_DETAILS, GET_ASSET_FLEET_ITEM_DETAILS, GET_ASSET_FLEET_TASK_DETAILS, GET_ASSET_OREDR_HEADER_DETAILS, SAVE_ASSET_ASSIGNED_TO_FOR_ALL_ITEM } from "../../Store/FleetManagement/AssetFleetProcessing/AssetFleetProcessingType";
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { CONSTANTS } from 'client/utils/constants';

function* getOrderHeaderDetailsSaga(req: any): any {
    try {
        yield put(globalLoaderText("Fetching values...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `fleet/asset/orderheader/${req?.orderId}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(FleetManagementApiService.post, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(setAssetOrderHeaderDetail(response));
        }
        yield put(globalLoaderText(""));
    } catch (error: any) {
        yield put(setAssetOrderHeaderDetail({}));
        yield put(globalLoaderText(""));
    }
}

function* getAfeOrderHeaderDetailsSaga(req: any): any {
    try {
        yield put(globalLoaderText("Fetching values...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `afe/fleet/orderheader/${req?.orderId}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(FleetManagementApiService.post, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(setAssetOrderHeaderDetail({...response, orderRequestType: CONSTANTS.AFEREQUEST}));
        }
        yield put(globalLoaderText(""));
    } catch (error: any) {
        yield put(setAssetOrderHeaderDetail({}));
        yield put(globalLoaderText(""));
    }
}

function* getFleetHeaderDetailsSaga(req: any): any {
    try {
        yield put(globalLoaderText("Fetching values...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `asset/fleet/fleetheader/${req?.orderId}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(FleetManagementApiService.post, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(setAssetFleetHeaderDetail(response));
        }
        yield put(globalLoaderText(""));
    } catch (error: any) {
        yield put(setAssetFleetHeaderDetail({}));
        yield put(globalLoaderText(""));
    }
}

function* getAfeFleetHeaderDetailsSaga(req: any): any {
    try {
        yield put(globalLoaderText("Fetching values...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `afe/fleet/fleetheader/${req?.orderId}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(FleetManagementApiService.post, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(setAfeFleetHeaderDetail(response));
        }
        yield put(globalLoaderText(""));
    } catch (error: any) {
        yield put(setAfeFleetHeaderDetail({}));
        yield put(globalLoaderText(""));
    }
}

function* getAssetFleetItemDetailsSaga(req: any): any {
    try {
        yield put(globalLoaderText("Fetching values...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `asset/fleet/item/details/${req?.fleetRequestDetailId}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(FleetManagementApiService.post, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(setAssetFleetItemDetails({ response: response, fleetRequestDetailId: req?.fleetRequestDetailId }));
        }
        yield put(globalLoaderText(""));
    } catch (error: any) {
        yield put(setAssetFleetItemDetails({}));
        yield put(globalLoaderText(""));
    }
}

function* getAfeFleetItemDetailsSaga(req: any): any {
    try {
        yield put(globalLoaderText("Fetching values...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `afe/fleet/item/details/${req?.fleetRequestDetailId}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(FleetManagementApiService.post, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(setAfeFleetItemDetails({ response: response, fleetRequestDetailId: req?.fleetRequestDetailId }));
        }
        yield put(globalLoaderText(""));
    } catch (error: any) {
        yield put(setAfeFleetItemDetails({}));
        yield put(globalLoaderText(""));
    }
}

function* getAssetFleetTaskDetailsSaga(req: any): any {
    try {
        yield put(globalLoaderText("Fetching values...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `asset/fleet/item/task/${req?.fleetRequestDetailId}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(FleetManagementApiService.post, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(setAssetFleetTaskDetails({ response: response, fleetRequestDetailId: req?.fleetRequestDetailId }));
        }
        yield put(globalLoaderText(""));
    } catch (error: any) {
        yield put(setAssetFleetTaskDetails({}));
        yield put(globalLoaderText(""));
    }
}

function* getAfeFleetTaskDetailsSaga(req: any): any {
    try {
        yield put(globalLoaderText("Fetching values...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `afe/fleet/item/task/${req?.fleetRequestDetailId}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(FleetManagementApiService.post, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(setAfeFleetTaskDetails({ response: response, fleetRequestDetailId: req?.fleetRequestDetailId }));
        }
        yield put(globalLoaderText(""));
    } catch (error: any) {
        yield put(setAfeFleetItemDetails({}));
        yield put(globalLoaderText(""));
    }
}

function* saveAssetAssignedToForAllItem(req: any): any {
    try {
        yield put(globalLoaderText("Fetching values...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `fleet/asset/assignedTo`,
            apiMethod: apiMethod.POST,
            payload: req?.payload
        }
        const response = yield call(FleetManagementApiService.post, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(setAssetAssignedToForAllItem({ response: response, payload: req?.payload }));
        }
        yield put(globalLoaderText(""));
    } catch (error: any) {
        yield put(setAssetAssignedToForAllItem({}));
        yield put(globalLoaderText(""));
    }
}

function* pendingOrderSagaWatcher() {
    yield takeEvery(GET_ASSET_OREDR_HEADER_DETAILS, getOrderHeaderDetailsSaga);
    yield takeEvery(GET_AFE_ORDER_HEADER_DETAILS, getAfeOrderHeaderDetailsSaga);
    yield takeEvery(GET_ASSET_FLEET_HEADER_DETAILS, getFleetHeaderDetailsSaga);
    yield takeEvery(GET_AFE_FLEET_HEADER_DETAILS, getAfeFleetHeaderDetailsSaga);
    yield takeEvery(GET_ASSET_FLEET_ITEM_DETAILS, getAssetFleetItemDetailsSaga);
    yield takeEvery(GET_AFE_FLEET_ITEM_DETAILS, getAfeFleetItemDetailsSaga);
    yield takeEvery(GET_ASSET_FLEET_TASK_DETAILS, getAssetFleetTaskDetailsSaga)
    yield takeEvery(GET_AFE_FLEET_TASK_DETAILS, getAfeFleetTaskDetailsSaga)
    yield takeEvery(SAVE_ASSET_ASSIGNED_TO_FOR_ALL_ITEM, saveAssetAssignedToForAllItem)
}

export default function* combinedSaga() {
    yield all([pendingOrderSagaWatcher()]);
}
